import { BiHomeAlt } from "react-icons/bi";
import NextLink from "next/link";
export const HouseIcon = () => (
  <NextLink href="/">
    <BiHomeAlt size={24} className="cursor-pointer text-brand-primary" />
  </NextLink>
);
